import { Action, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import appReducer from './reducer';
import shoppingListReducer from './shoppingListSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        shoppingList: shoppingListReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, Action<string>>;